export default __webpack_public_path__ + "af3141e2cd475091edb53369f3a023a4.png";